import { Skeleton } from "~/components/ui/skeleton";

/**
 * Skeleton for the FSA/HSA eligibility + free-shipping badge row below
 * the ATC. Mirrors product-details.tsx L537-595 markup so the section
 * reserves the same vertical space during streaming.
 */
export const BadgesSkeleton = () => {
  return (
    <section
      aria-label="Product badges loading"
      className="badges-skeleton mt-3 flex w-full flex-wrap items-center gap-4 pl-5 sm:px-0"
    >
      <Skeleton className="h-5 w-44" />
      <Skeleton className="h-5 w-40" />
    </section>
  );
};
